import type { IpPoolResponse } from "@warrenio/api-spec/spec.oats.gen";

export const adminIpPoolExample: IpPoolResponse = {
    used_ips: 627,
    total_ips: 880,
    percent_used: 81.25,
};
